<template>
    <div v-if="table">
        <div v-if="table.isLoading && !table.loadingMoreData" class="loading"><span class="loader">Loading...</span></div>
        <div class="scroll-table" id="scrollTable">
            <div v-if="!table.isLoading && tableData && tableData.length === 0" class="no-data">{{noDataErrorMsg}}</div>
            <table class="data-table" v-if="tableData && tableData.length > 0">
                <thead>
                    <tr>
                        <template v-for="(col, index) in table.columns" v-bind:key="index">
                        <th v-if="!col.rowData && col.isVisible" :class="{'sortby': isSortOnThisColumn(col), 'sortable': isSortableColumn(col) === true, 'asc': table.sortOrder == 'asc', 'desc': table.sortOrder == 'desc'}" @click.prevent="setSortDetails($event, col)">
                            <span v-html="col.displayName" :class="col.headerClass" :title="(isSortableColumn(col) ? 'Sort By ' : '') + col.helpText"></span>
							<i class="fa fa-angle-down arrow down" v-if="isSortOnThisColumn(col) && table.sortOrder === 'desc'"  />
							<i class="fa fa-angle-up arrow up" v-if="isSortOnThisColumn(col) && table.sortOrder === 'asc'"  />
                        </th>
                        </template>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(row, $index) in tableData" v-bind:key="$index">
                        <template v-for="(col, index) in table.columns" v-bind:key="index">
                            <tr v-if="col.rowData" v-bind:key="$index+''+index" class="title-row">
                                <td v-bind:colspan="table.totalColumns" class="title-row" :class="'column-' + col.fieldName" :data-label="col.displayName">
                                    <template v-if="col.refURLField && row[col.refURLField] && row[col.refURLField].value">
                                        <a @click="trackThis(col); goToPage(row, col)" :target="col.internalLink ? '' : '_blank'" :href="row[col.refURLField].value" rel="noopener">{{ filters.globalFormat(row[col.fieldName], (col.formatType ? col.formatType : ''))}}</a>
                                    </template>
                                    <span v-else>{{row[col.fieldName]}}</span>
                                </td>
                            </tr>
                        </template>
                            <tr>
                                <template v-for="(col, index, colCount) in table.columns">
                                    <template v-if="!col.rowData">
                                        <td  v-bind:key="index" v-if="checkIfVisible(col, row, colCount)" :class="col.cssClass + ' ' + 'column-' + col.fieldName" v-bind:colspan="getColSpan(col, row, colCount)" :data-label="col.displayName">
                                            <template v-if="col.refURL || col.refURLField">
                                                <template v-if="col.fieldName === 'coreprojects'" >
                                                    <div class="project-description-data-wrapper" :class="{'show-all': row[col.fieldName] && row[col.fieldName].length <= 5}">
                                                        <div class="project-description-data">
                                                            <template v-for="(proj, projIndex) in row[col.fieldName]" :key="'link-' + projIndex" >
                                                                <a @click="trackThis(col); goToPage(row, col, null, coreProjectsUrl(row, projIndex))" :href="coreProjectsUrl(row, projIndex)" :target="col.internalLink ? '' : '_blank'" :class="{'button': col.fieldType === 'button'}" rel="noopener">
                                                                    {{proj}}<span v-if="projIndex + 1 !== row[col.fieldName].length">;</span>
                                                                </a>
                                                                <br v-if="projIndex + 1 !== row[col.fieldName].length" :key="'link-' + projIndex + '-br'"/>
                                                            </template>
                                                        </div>
                                                        <button :id="'btn' + $index + '_' + index" class="project-button" @click.prevent="expandDescription('btn' + $index + '_' + index)" v-if="row[col.fieldName] && row[col.fieldName].length > 5">View
                                                            <span class="more">All</span><span class="less">Less</span>
                                                        </button>
                                                    </div>
                                                </template>
                                                <a v-else @click="trackThis(col); goToPage(row, col)" :href="row[col.refURLField] ? row[col.refURLField].value : ''" :target="col.internalLink ? '' : '_blank'" :class="{'button': col.fieldType === 'button'}" rel="noopener">
                                                    <span v-if="col.fieldName">{{ filters.globalFormat(row[col.fieldName], (col.formatType ? col.formatType : ''))}}
                                                    </span>
                                                    <template v-if="col.fieldName === 'journal_title'">
                                                        <template v-if="row.pub_date">{{row.pub_date}};</template> {{row.journal_volume}} <template v-if="row.journal_issue">({{row.journal_issue}})</template> <template v-if="row.page_number">{{row.page_number}}</template>
                                                    </template>
                                                </a>
                                                <template v-if="col.fieldName === 'journal_title' && row.nct_ids">
                                                    <div class="clinical-trials">
                                                        Clinical Trials cited include:
                                                        <span v-for="(link, linkIndex) in row.nct_ids.split(';')" v-bind:key="'link-' + index + '-' + linkIndex" ><a target="_blank" :href="externalURLs.REPORTER_CLINICAL_TRIAL_URL.replace('{0}',link)">{{link}}
                                                        </a></span>
                                                    </div>
                                                </template>
                                                <template v-if="col.fieldName === 'core_project_num' && row.other_related_grants">
                                                    <b-link class="additional-data" href="javascript:void(0)" role="button" v-b-toggle="'row' + $index + '-' + colCount" aria-expanded="false" :aria-controls="'row' + $index + '-' + colCount" rel="noopener">Other Supporting Projects</b-link>
                                                    <b-collapse :id="'row' + $index + '-' + colCount" >
                                                        <template v-for="(other, otherIndex) in row.other_related_grants.split(';')">
                                                            <a @click.prevent="trackThis(col);  goToPage(row, col, other)" href :class="{'button': col.fieldType === 'button'}" rel="noopener">{{other}}</a><br />
                                                        </template>
                                                    </b-collapse>
                                                </template>
                                            </template>
                                            <span v-else-if="col.fieldType && col.fieldType === 'icon'" :class="{'icon': col.fieldType === 'icon'}">
                                                <template v-for="(icon, iconInd) in col.icons">
                                                    <a  v-bind:key="'icon' + index + iconInd" @click="trackThis(col); goToPage(row, col)" :target="col.internalLink ? '' : '_blank'" :href="row[icon.fieldName].value" v-if="row[icon.fieldName].value" rel="noopener">
                                                        <img v-if="icon.type==='image'" :style="icon.cssStyle" :alt="icon.alt" :src="icon.name"/>
                                                        <i v-else class="row-button-icon" :style="icon.cssStyle" :class="icon.name"/>
                                                        <span class="sr-only">{{col.displayName}}</span>
                                                    </a>
                                                    <span v-else style="width:25px; height:20px; display: inline-block;"></span>
                                                </template>
                                            </span>
                                            <span v-else>
                                                <span v-if="col.alternateField && row[col.alternateField] != null">{{filters.globalFormat(row[col.alternateField], (col.formatType ? col.formatType : ''))}}
                                                </span>
                                                <div v-if="col.fieldName && row[col.fieldName] && col.truncateData" class="project-description-data-wrapper" :class="{'show-all': row[col.fieldName] && row[col.fieldName].length <= 150}">
                                                    <div class="project-description-data">
                                                        {{filters.globalFormat(row[col.fieldName], (col.formatType ? col.formatType : ''))}}
                                                    </div>
                                                    <button :id="'btn' + $index + '_' + index" class="project-button" @click.prevent="expandDescription('btn' + $index + '_' + index)" v-if="row[col.fieldName] && row[col.fieldName].length > 150">View
                                                        <span class="more">All</span><span class="less">Less</span>
                                                    </button>
                                                </div>
                                                <div v-else-if="col.fieldName && row[col.fieldName]">
                                                    <span v-if="col.fieldName === 'relative_citation_ratio'" class="RCR">
                                                        <img src="/img/icite.png" height="16px" alt="iCite">
                                                        {{filters.globalFormat(row[col.fieldName], (col.formatType ? col.formatType : ''))}}
                                                    </span>
                                                    <template v-else>
                                                        {{filters.globalFormat(row[col.fieldName], (col.formatType ? col.formatType : ''))}}
                                                    </template>

                                                </div>
                                            </span>
                                        </td>
                                    </template>
                                </template>
                            </tr>
                    </template>
                </tbody>
            </table>
            
            <table :id="(this.id ? 'cln-' + this.id : 'clnTable')" aria-hidden="true" class="data-table" :class="{'fixed-within': id, 'fixed-header': !id}" v-if="tableData && tableData.length > 0 && id !== 'fundingProjectDetails'">
                <thead>
                    <tr>
                        <template v-for="(col, index) in table.columns" v-bind:key="index">
                        <th v-if="!col.rowData && col.isVisible" :class="{'sortby': isSortOnThisColumn(col), 'sortable': isSortableColumn(col) === true, 'asc': table.sortOrder == 'asc', 'desc': table.sortOrder == 'desc', ['column-' + col.fieldName]: true}" @click.prevent="setSortDetails($event, col)">
                            <span v-html="col.displayName" :class="col.headerClass" :title="(isSortableColumn(col) ? 'Sort By ' : '') + col.helpText"></span>
							<i class="fa fa-angle-down arrow down" v-if="isSortOnThisColumn(col) && table.sortOrder === 'desc'"  />
							<i class="fa fa-angle-up arrow up" v-if="isSortOnThisColumn(col) && table.sortOrder === 'asc'"  />
                        </th>
                        </template>
                    </tr>
                </thead>
            </table>
        </div>
        <span class="more-data-loader" v-if="table.loadingMoreData">Loading</span>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import winHandlerMixins from '@/shared/winhandlerMixins';
    import dataTableMixins from '@/shared/dataTable.mixin.js';
    import bus from '@/shared/event-bus.js';
    import {app} from '@/main';

    export default {
        name: 'pubDataTable',
        props: [
            'id',
            'table',
            'fromPage',
            'containerScrolling',
            'isFixedTable'
        ],
        mixins: [winHandlerMixins, dataTableMixins],
        computed: {
            ...mapGetters([
                'noDataErrorMsg'
            ]),
        },
        data: function () {
            return {
                scrollingTimer: 0,
                limitBy: 50,
                limitByAmount: 50,
                tableData: null,
                tableMeta: null,
                expanded: [],
                filters: null
            }
        },
        created () {
            var self = this;
            self.filters = app.$options.$filters;

            setTimeout(() => {
                self.initTableData();
            });
        },
        methods: {
            coreProjectsUrl (row, projIndex) {
                return '/publications/' + this.$route.params.search_id + '/project-details/' + row.applids[projIndex];
            },
            initTableData () {
                var self = this,
                    pubSearchResults,
                    applCoreObj = [];

                switch (self.fromPage) {
                    case 'publications':
                        self.tableData = copyData(self.$store.state.publicationResults.results);
                        self.tableMeta = self.$store.state.publicationResults.meta;
                        break;
                    case 'publications-search':
                        self.table.loadingMoreData = false;
                        pubSearchResults = copyData(self.$store.state.publicationResults.results.slice(0, this.table.offset + this.table.limit));

                        for (let i = 0; i < pubSearchResults.length; i++) {
                            applCoreObj = [];
                            for (let j = 0; j < pubSearchResults[i].coreprojects.length; j++) {
                                applCoreObj.push({
                                    coreProjectNo: pubSearchResults[i].coreprojects[j],
                                    applId: pubSearchResults[i].applids[j]
                                });
                            }
                            applCoreObj =  _.orderBy(applCoreObj, 'coreProjectNo', ['asc']);
                            pubSearchResults[i].coreprojects = [];
                            pubSearchResults[i].applids = [];
                            for (let j = 0; j < applCoreObj.length; j++) {
                               pubSearchResults[i].coreprojects.push(applCoreObj[j].coreProjectNo);
                               pubSearchResults[i].applids.push(applCoreObj[j].applId);
                            }
                        }
                        self.tableData = copyData(pubSearchResults);
                        self.tableMeta = self.$store.state.publicationResults.meta;
                        break;
                    case 'projectDetails':
                        if (self.$store.state.projectDetails.publications) {
                            self.tableData = self.$store.state.projectDetails.publications.results.slice(0, this.table.offset + this.table.limit);
                        }
                    break;
                }
                setTimeout(() => {
                    if (self.tableData && self.tableData.length > 0) {
                        // document.querySelectorAll('[data-toggle="tooltip"]').tooltip();
                        if (!this.containerScrolling) {
                            window.fixHeaders('scrollTable');
                        } else {
                            this.fixSubPageTableHeaders('pubDataTableContainer');
                        }
                    }
                }, 101);
            },
            expandDescription (curId) {
                var descriptionContainer = (event.target.nodeName === 'SPAN' ? event.target.parentNode.parentNode : event.target.parentNode),
                    reportFootnotes = descriptionContainer.querySelector('.project-description-data');

                if (descriptionContainer.classList && descriptionContainer.classList.value.indexOf('expanded') === -1) {

                    this.savedHeight = descriptionContainer.offsetHeight;

                    descriptionContainer.style.height = this.savedHeight;

                    this.$nextTick(() => {
                        descriptionContainer.style = {
                            height: (reportFootnotes.length > 0 ? reportFootnotes[0].offsetHeight : reportFootnotes.offsetHeight),
                            'max-height': 'none'
                        }
                        descriptionContainer.classList.add('expanded');
                    });
                } else {
                    descriptionContainer.style.height = this.savedHeight;

                    this.$nextTick(() => {
                        descriptionContainer.classList.remove('expanded');
                    });
                }
            },
            isSortableColumn (col) {
                return !!col.isSortable;
            },
            isSortOnThisColumn (col) {
                var sortFieldName = col.fieldName;


                if (col.sortFieldName) {
                    sortFieldName = col.sortFieldName;
                } else if (col.subField) {
                    sortFieldName = col.subField;
                }

                if (sortFieldName !== '' && this.table.sortField === sortFieldName) {
                    return true;
                } else if (this.tableMeta && this.tableMeta.sort_field && this.tableMeta.sort_field === sortFieldName) {
                    return true;
                } else  if (this.fromPage !== 'searchResults') {
                    return this.table.sortField === col.fieldName && col.fieldName !== '';
                }

                return false;
            },
            trackThis (col, subCol) {
				gtag('event', 'Click', {
					'event_category': 'Search Results',
					'event_label': 'Search Results - clicked on ' + col.displayName + ' (' + col.fieldName + ')',
					'value': 'Search Results - clicked on ' + col.displayName + ' (' + col.fieldName + ')'
				});	
            },
            goToPage (row, col, coreProjNum, passedUrl) {
                if (coreProjNum) {
                    bus.$emit('get-applId', coreProjNum, this.handleAppId);
                } else if (passedUrl) {
                    event.preventDefault();

                    if (passedUrl !== '') {
                        this.$router.push({
                            path: passedUrl
                        });
                    }
                }
                else if (col.internalLink) {
                    event.preventDefault();
                    var url = this.buildURLString(row, col);

                    if (url !== '') {
                        this.$router.push({
                            path: url
                        });
                    }
                }
                return false;
            },
            handleAppId (data) {
                if (data) {
                    if (this.$route.params.search_id) {
                        this.$router.push({
                            path: '/search/' + this.$route.params.search_id + '/publications/project-details/' + data
                        });
                    } else {
                        this.$router.push({
                            path: '/project-details/' + data
                        });
                    }
                }
            },
            checkIfVisible (col, row, colCount) {
                if (!col.rowData) {
                    if (col.isAlternateColumn) {
                        if ((col.alternateField && row[col.alternateField] != null) || row.admin_icd_long_abbr === 'ACF') {
                            return false;
                        }
                    } else if (!col.isVisible) {
                        return false;
                    }

                }
                return true;
            },
            getColSpan (col, row, colCount) {
                if (col.alternateField && row[col.alternateField] != null && colCount === 1) {
                    return 4;
                } else if (row.admin_icd_long_abbr === 'ACF' && colCount === 1) {
                    return 4;
                }
                return 1;
            },
            getSortedList (data) {
                var sortedData = [];
                if (data && data.length > 1) {
                    for (let i = 0; i < data.length; i++) {
                        if (data[i].role_code === 'PI') {
                            sortedData.unshift(data[i]);
                        } else {
                            sortedData.push(data[i]);
                        }
                    }
                    data = sortedData;
                }
                return data;
            },
            backToQuery () {
                this.$router.push('/');
            },
            isObject (data, fieldName) {
                return typeof (data) === 'object' && data !== null;
            },
            setSortDetails ($event, selectedSortColumn) {
                var self = this;

                if (self.isSortableColumn(selectedSortColumn)) {
                    self.table.isLoading = true;
                    bus.$emit('sort-column', $event, selectedSortColumn);
                }
            },
            getRemainingName (fieldData) {
                var nameStr = '',
                    i = 0;

                if (fieldData.length > 1) {
                    for (i = 1; i < fieldData.length; i++) {
                        nameStr += (nameStr === '' ? fieldData[i].name : '\n' + fieldData[i].name);
                    }
                }
                return nameStr;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/scss/variables.scss';

    .scroll-table {
        overflow: hidden;
        position: relative;
        .clinical-trials {
            margin-top: 10px;
            font-weight: bold;
            span {
                font-weight: normal;
                display: block;
            }
        }
        .RCR {
            white-space: pre;
            svg {
                width: 33px;
                margin-right: 5px;
                vertical-align: middle;
            }
        }
         .project-description-data-wrapper {
                max-height: 5em;
                padding-bottom: 25px;
                overflow: hidden;
                position: relative;

                &:not(.no-data) {
                    &:before {
                        content: "";
                        position: absolute;
                        bottom: 18px;
                        left: 0;
                        width: 100%;
                        height: 2rem;
                        background: linear-gradient(to bottom, rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%);
                        pointer-events: none;
                        transition: 1s;
                    }
                    &:after {
                        content: "";
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        width: 100%;
                        height: 18px;
                        background-color: #fff;
                        pointer-events: none;
                        transition: 1s;
                    }

                    &.expanded {
                        max-height: none;
                        &:before,
                        &:after {
                            opacity: 0;
                        }
                    }
                }

                .less {
                    display: none;
                }
                .more {
                    display: inline;
                }

                &.no-data {
                    padding: 0;
                    font-size: 16px;
                }

                .project-description-data {
                    min-height: 1vh;
                    .data {
                        margin-bottom: 5px;
                    }
                }
                &.show-all {
                    max-height: 100%;
                    padding-bottom: 0;
                    .project-description-data {
                        min-height: auto;
                    }
                    &:before , &:after{
                        display: none;
                    }
                }
                .project-button {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    min-width: 72px;
                    z-index: 10;
                    border: none;
                    background: $blue-nih;
                    padding: 4px 20px;
                    color: $white;
                    border-radius: 35px;
                    transition: 0.3s;
                    cursor: pointer;
                    font-weight: 500;
                    &:hover,
                    &:focus {
                        outline: none;
                    }


                }
                &.expanded {
                    .more {
                        display: none;
                    }
                    .less {
                        display: inline;
                    }
                }

            }
    }

    .tooltip-toggle::before {
        position: absolute;
        top: 25px;
        left: 0px;
        background-color: #dcdcdc;
        border-radius: 5px;
        color: $grey-link;
        content: attr(data-tooltip);
        padding: 2px 5px;
        text-transform: none;
        -webkit-transition: all 0.5s ease;
        transition: all 0.5s ease;
        width: 100%;
        z-index: 1000;
        box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.2);
        word-break: break-word;

        .tooltip-toggle::after {
            position: absolute;
            top: -12px;
            left: 9px;
            border-left: 1px solid transparent;
            border-right: 1px solid transparent;
            border-top: 1px solid #dcdcdc;
            content: " ";
            font-size: 0;
            line-height: 0;
            margin-left: -5px;
            width: 0;
        }
    }

    .tooltip-toggle:hover::before,
    .tooltip-toggle:hover::after {
        opacity: 1;
        -webkit-transition: all 0.75s ease;
        transition: all 0.75s ease;
        color: $grey-link;
    }

    .tooltip-toggle::before,
    .tooltip-toggle::after {
        color: #efefef;
        opacity: 0;
        pointer-events: none;
        text-align: left;
    }

    .more-data-loader {
        display: block;
        position: absolute;
        background-color: #555;
        color: #fff;
        font-size: 13px;
        padding: 2px 5px;
        bottom: 0;
        right: 0px;
        z-index: 10;
    }

    .loading {
            position: absolute;
    width: 100%;
    height: 100%;
    z-index: 1000;

    background-color: #a0a0a0;
    opacity: 0.5;
    .loader {
        color: #000;
        left: 45%;
        top: 3%;
    }
    }

</style>
